import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const LoginModal = ({ isOpen, onClose, onSwitchToRegister, onShowForgotPassword, onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showResendOption, setShowResendOption] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const { login, loginWithGoogle, resendVerificationEmail } = useAuth();

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setShowResendOption(false);
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      onClose();
      setEmail('');
      setPassword('');
      // Call success callback if provided
      if (onLoginSuccess) {
        onLoginSuccess();
      }
    } else {
      setError(result.error);
      // Show resend option if email is not verified
      if (result.code === 'EMAIL_NOT_VERIFIED') {
        setShowResendOption(true);
      }
    }
    setLoading(false);
  };

  const handleResendVerification = async () => {
    setResendLoading(true);
    setError('');

    const result = await resendVerificationEmail(email);
    
    if (result.success) {
      setError('Verification email sent! Please check your inbox.');
      setShowResendOption(false);
    } else {
      setError(result.error);
    }
    
    setResendLoading(false);
  };

  const handleGoogleLogin = () => {
    loginWithGoogle();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-header">
          <h2>Welcome Back!</h2>
          <p>Login to continue creating AI fashion videos</p>
        </div>

        {error && (
          <div className="error-message">
            ⚠️ {error}
            {showResendOption && (
              <div className="resend-section">
                <button 
                  className="btn-resend-small" 
                  onClick={handleResendVerification}
                  disabled={resendLoading}
                >
                  {resendLoading ? 'Sending...' : 'Resend Verification Email'}
                </button>
              </div>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="btn-submit" 
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="forgot-password-section">
          <button
            type="button"
            onClick={onShowForgotPassword}
            className="forgot-password-link"
            disabled={loading}
          >
            🔑 Forgot your password?
          </button>
        </div>

        <div className="divider">
          <span>OR</span>
        </div>

        <button 
          className="btn-google" 
          onClick={handleGoogleLogin}
          disabled={loading}
        >
          <span className="google-icon">G</span>
          Continue with Google
        </button>

        <div className="enhanced-modal-footer">
          <p>
            Don't have an account?
            <button 
              className="enhanced-link-button" 
              onClick={onSwitchToRegister}
              disabled={loading}
            >
              Sign up
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
